// @ts-nocheck
import { cn } from '@/lib/utils';
import { ReactNode } from 'react';

type Props = {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
};

export const MobileEmptyState = ({
  icon,
  title,
  description,
  action,
  className,
}: Props) => {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center px-6 py-12',
        className,
      )}
    >
      {icon && (
        <div className="h-16 w-16 rounded-full bg-muted flex items-center justify-center mb-3 text-muted-foreground">
          {icon}
        </div>
      )}
      <p className="font-semibold text-base">{title}</p>
      {description && (
        <p className="mt-1 text-sm text-muted-foreground max-w-[260px]">
          {description}
        </p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
};
